import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { FacilityModel } from '../../models/facility';

const getOtherFacilityIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<FacilityModel>) => memoize((
        ids: Undefinable<number>[]
    ) => ids.filter(x => x && !byId[x]) as number[])
);

export const selectors = {
    getFacility: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<FacilityModel> => state.byId[id || ''],
    getFacilityIds: (
        state: State
    ): number[] => state.allIds,
    getOtherFacilityIds: (
        state: State,
        ids: Undefinable<number>[]
    ): number[] => getOtherFacilityIdsSelector(state)(ids)
};
